import React from "react";
import LogoUpdaterComponent from "./logoUpdaterComponent";
import ResponseProcessorService from "../../ports/backend/ResponseProcessorService";
import BackendConnectionService from "../../ports/backend/backendConnectionService";

export default class LogoUploaderForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            headerLogo: props.headerLogo || null,
            loginLogo: props.loginLogo || null,
            requestInProgress: false
        };
    }

    componentDidMount() {
        this.setState({
            requestInProgress: true
        });
        
        BackendConnectionService.getInstanceConfiguration()
        .then((e) => {
            this.setState({
                headerLogo: e.data.headerLogo,
                loginLogo: e.data.adminLogo
            });
        })
        .catch((e) => {
            ResponseProcessorService.processError(e);
        }).finally(() => {
            this.setState({
                requestInProgress: false
            });
        });
    }

    render() {
        let { requestInProgress, headerLogo, loginLogo } = this.state;
        if (requestInProgress) {
            return <div>Cargando...</div>;
        }
        return (
            <div className="card">
                <div className="card-body p-4">
                    <div className="p-2">
                        <h5 className="mb-5 text-center">Cambiar logos</h5>
                        <LogoUpdaterComponent logo="header" current={headerLogo} />

                        <LogoUpdaterComponent logo="login" current={loginLogo} />
                    </div>
                </div>
            </div>
        );
    }
}